import { generateTypes, promisify } from "../../../utilities";
import SuperTableShim from "../../common/SuperTableShim";

import { RS } from "../../../data/strings/global";
import * as SC from "../../../data/strings/PIStringConst";

import * as gbtu from "../../GB/GBTableUtil";
import * as piasu from "../NonComponents/PIAppStateUtil";
import * as pisc from "../NonComponents/PIServerConst";
import * as gbtc from "../../GB/GBTableConst";

const methodNameCol = 0;
const costsCol = 1;

const headerRow = 0;

const PICostCatMethodAboveSiteTable = (props) => {
  const { modVarObjList, onModVarsChange } = props;

  const methodObjArr = piasu.getModVarValue(modVarObjList, pisc.methodsMVTag);
  const numMethods = piasu.getTotalNumMethods(methodObjArr);

  const annualLumpSumCosts = piasu.getModVarValue(modVarObjList, pisc.annualLumpSumMVTag);

  const onPackTableChange = async (newPackTable) => {
    const onModVarsChangeAsync = promisify(onModVarsChange);
    const modVarObjListClone = structuredClone(modVarObjList);
    const newAnnualLumpSumCosts = piasu.getModVarValue(modVarObjListClone, pisc.annualLumpSumMVTag);

    for (let m = 0; m < numMethods; m++) {
      newAnnualLumpSumCosts[m] = gbtu.getValue(newPackTable, m + 1, costsCol);
    }

    await onModVarsChangeAsync(modVarObjListClone, false);
  };

  // Table
  const numRows = numMethods + 1;
  const numCols = 2;
  const packTable = gbtu.resizePackTable(gbtu.getNewPackTable(), numRows, numCols);

  gbtu.setValue(packTable, headerRow, methodNameCol, RS(SC.GB_stMethod));
  gbtu.setValue(packTable, headerRow, costsCol, RS(SC.GB_stAnnLumpSumCosts));
  gbtu.setMaxAllowedValForTable(packTable, gbtc.maxInt);

  gbtu.setColWidth(packTable, costsCol, 175);
  gbtu.setRowAlignment(packTable, headerRow, gbtc.hAlign.center);

  for (let m = 0; m < numMethods; m++) {
    const method = methodObjArr[m];
    const cost = annualLumpSumCosts[m];
    gbtu.setValue(packTable, m + 1, methodNameCol, method.name);
    gbtu.setValue(packTable, m + 1, costsCol, cost);
  }

  const types = generateTypes(packTable);

  return <SuperTableShim packTable={packTable} types={types} onPackTableChanged={onPackTableChange} />;
};

export default PICostCatMethodAboveSiteTable;
